import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _toConsumableArray from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _get from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Guard, Result, UniqueEntityID } from '@digibricks/core';
import { EssayAnswerReport } from '../answer-report';
import { QuestionReport } from './question-report';
export var EssayQuestionReport = /*#__PURE__*/function (_QuestionReport) {
  _inherits(EssayQuestionReport, _QuestionReport);

  var _super = _createSuper(EssayQuestionReport);

  function EssayQuestionReport() {
    _classCallCheck(this, EssayQuestionReport);

    return _super.apply(this, arguments);
  }

  _createClass(EssayQuestionReport, [{
    key: "answerReports",
    get: function get() {
      return this.props.answerReports;
    }
  }], [{
    key: "create",
    value: function create(props) {
      var guardCollection = [{
        argument: props.answerReports,
        argumentName: 'Answer Reports'
      }];
      var guardResult = Guard.againstNullOrUndefinedBulk(guardCollection);

      if (!guardResult.succeeded) {
        return Result.fail(guardResult.message);
      }

      return Result.ok(new EssayQuestionReport(props, new UniqueEntityID(props.id.toString())));
    }
  }, {
    key: "fromJson",
    value: function fromJson(data) {
      try {
        var answerReports = data.answerReports;

        var basePropsOrError = _get(_getPrototypeOf(EssayQuestionReport), "createBaseProps", this).call(this, data);

        if (basePropsOrError.isFailure) {
          return Result.fail(basePropsOrError.error);
        }

        var baseProps = basePropsOrError.getValue();

        var essayAnswerReportProps = _toConsumableArray(answerReports);

        var essayAnswerReportsOrError = essayAnswerReportProps === null || essayAnswerReportProps === void 0 ? void 0 : essayAnswerReportProps.map(function (answerReport) {
          return EssayAnswerReport.fromJson(answerReport);
        });
        var essayAnswerReportResultOrErrorCombined = Result.combineArray(essayAnswerReportsOrError);
        if (essayAnswerReportResultOrErrorCombined.isFailure) return Result.fail(essayAnswerReportResultOrErrorCombined.error);
        var essayAnswerReports = essayAnswerReportResultOrErrorCombined.getValue();
        var essayQuestionReportOrError = this.create(_objectSpread(_objectSpread({}, baseProps), {}, {
          answerReports: essayAnswerReports
        }));

        if (essayQuestionReportOrError.isFailure) {
          return Result.fail(essayQuestionReportOrError.error);
        }

        var essayQuestionReport = essayQuestionReportOrError.getValue();
        return Result.ok(essayQuestionReport);
      } catch (error) {
        return Result.fail(error);
      }
    }
  }]);

  return EssayQuestionReport;
}(QuestionReport);